export default "__VITE_ASSET__CYNH5qXZ__"